import { useQuery } from "@tanstack/react-query";
import { useEvent } from "../context/EventProvider";
import { fetchCompanions, type Companion } from "./companions";
import { useParticipation } from "./useParticipation";

/**
 * LES ACCOMPAGNANTS DE CETTE PERSONNE.
 *
 * ⚠️ DEMANDÉS SEULEMENT QUAND L'ÉVÉNEMENT EN ACCEPTE, comme les conférences et la
 * billetterie : sinon c'est une requête de plus sur chaque confirmation de chaque
 * événement, pour une section qui ne s'afficherait jamais. La plupart n'en ont pas.
 */
export function useCompanions(active: boolean): {
  companions: ReadonlyArray<Companion>;
  loading: boolean;
} {
  const event = useEvent();
  const { me } = useParticipation();

  const q = useQuery({
    queryKey: ["accompagnants", event?.domainId, event?.eventId, me?.id],
    queryFn: ({ signal }) =>
      fetchCompanions(event!.domainId, event!.eventId, me!.id, signal),
    enabled: active && !!event && typeof me?.id === "number",
    /* La liste ne bouge pas pendant qu'on lit sa confirmation : on n'ajoute un
       accompagnant que depuis son propre écran, qui invalidera cette clé. */
    staleTime: Infinity,
    retry: false,
  });

  return {
    companions: q.data ?? [],
    loading: active && q.isPending,
  };
}
